import { CreateResponsibleMedicalRecordLinkUseCase } from './domain/useCases/createResponsibleMedicalRecordLinkUseCase'
import { GetResponsibleMedicalRecordForReviewUseCase } from './domain/useCases/getResponsibleMedicalRecordForReviewUseCase'
import { GetResponsibleMedicalRecordForViewUseCase } from './domain/useCases/getResponsibleMedicalRecordForViewUseCase'
import { GetResponsibleMedicalRecordUseCase } from './domain/useCases/getResponsibleMedicalRecordUseCase'
import { ListResponsibleMedicalRecordUseCase } from './domain/useCases/listResponsibleMedicalRecordUseCase'
import { ReviewResponsibleMedicalRecordUseCase } from './domain/useCases/reviewResponsibleMedicalRecordUseCase'
import { SetResponsibleMedicalRecordCompletedUseCase } from './domain/useCases/setResponsibleMedicalRecordCompletedUseCase'
import { SetResponsibleMedicalRecordExpiredUseCase } from './domain/useCases/setResponsibleMedicalRecordExpiredUseCase'
import { UpdateResponsibleMedicalRecordUseCase } from './domain/useCases/updateResponsibleMedicalRecordUseCase'
import { responsibleMedicalRecordDatasourceAdapter } from './external/datasources/responsibleMedicalRecordDatasourceAdapter'
import { responsibleMedicalRecordRepositoryAdapter } from './infra/repositories/responsibleMedicalRecordRepositoryAdapter'

const repository = responsibleMedicalRecordRepositoryAdapter(
  responsibleMedicalRecordDatasourceAdapter
)

export const responsibleMedicalRecordInstance = {
  getResponsibleMedicalRecord: GetResponsibleMedicalRecordUseCase(repository),
  updateResponsibleMedicalRecord:
    UpdateResponsibleMedicalRecordUseCase(repository),
  setResponsibleMedicalRecordExpired:
    SetResponsibleMedicalRecordExpiredUseCase(repository),
  setResponsibleMedicalRecordCompleted:
    SetResponsibleMedicalRecordCompletedUseCase(repository),
  createResponsibleMedicalRecordLink:
    CreateResponsibleMedicalRecordLinkUseCase(repository),
  listResponsibleMedicalRecord: ListResponsibleMedicalRecordUseCase(repository),
  getResponsibleMedicalRecordForReview:
    GetResponsibleMedicalRecordForReviewUseCase(repository),
  getResponsibleMedicalRecordForView:
    GetResponsibleMedicalRecordForViewUseCase(repository),
  reviewResponsibleMedicalRecord:
    ReviewResponsibleMedicalRecordUseCase(repository)
}
